import './App.css';
import {Routes} from 'react-router-dom';
import {PRODUCTION_MODE} from 'helpers/Functions';
import VersionModal from 'components/Modal/VersionModal';
import NetConnection from "components/Modal/NetConnection";
import {detectPathUrl} from "helpers/detectPathUrl";
import {getRoutes} from "helpers/getRoutes";
import {mainRoutes} from "helpers/applicationRoutes/mainRoutes";
import {AppLoaded} from "components/AppLoaded";

function App() {
    // for remove console.log in production
    if (PRODUCTION_MODE) {
        console.log = function () {};
    }

    return (
        <>
            <AppLoaded/>
            <NetConnection/>
            <Routes basename={detectPathUrl('')}>
                {getRoutes(mainRoutes)}
            </Routes>
        </>
    );
}

export default App;
